import { useEffect, useRef, useState } from 'react';

// Embeds the standalone canvas game (public/the-route-game.html) in an iframe.
// The game runs a continuous requestAnimationFrame loop, so we only mount it
// while the section is on screen — otherwise it burns CPU and makes the whole
// page scroll laggy even when scrolled far past it.
export default function RouteGame() {
  const ref = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { rootMargin: '150px 0px', threshold: 0.01 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      id="the-route"
      className="bg-[#060a12] h-[520px] sm:h-[640px] lg:h-[740px]"
    >
      {inView && (
        <iframe
          src="/the-route-game.html"
          title="The Route — a LocalContact mini-game"
          className="block w-full h-full border-0"
        />
      )}
    </section>
  );
}
